import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { OrganizationProvider, RelyantAuthProvider } from '@relyant/ui';

const root = createRoot(document.getElementById('root'));
root.render(
  <RelyantAuthProvider>
    <OrganizationProvider>
      <App />
    </OrganizationProvider>
  </RelyantAuthProvider>
);
